import { createEvent } from './createEvent'

export function dispatch(json: string): void {
  let detail = {}

  try {
    detail = JSON.parse(json)
  } catch (e) {
    throw new Error(e.message)
  }

  const event = createEvent(detail)

  window.dispatchEvent(event)
}
